export default {
  companyManager: {
    //获取企业列表
    loadEnterprise: "/api/companyManager/loadEnterprise",
    getEnterpriseList: "api/companyManager/getEnterpriseList",
    addEnterprise: "api/companyManager/addEnterprise",
    updateEnterprise: "api/companyManager/updateEnterprise",
    delEnterprise: 'api/companyManager/delEnterprise',
    exportTemplate: "/api/companyManager/exportTemplate",
    importData: "/api/companyManager/importData",
    exportEnterprise: '/api/companyManager/exportEnterprise',
    getEnterprise: "api/companyManager/getEnterprise",
    delEnterpriseInfoDetailIds: "api/companyManager/delEnterpriseInfoDetailIds",
    getEnterpriseManagerSByCodeList: "/api/companyManager/getEnterpriseManagerSByCodeList",

  },
}